import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, NavController, NavParams } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { FlavorsPageComponent } from '../flavors-page/flavors-page.component';
import { NutritionAllergyPageComponent } from '../nutrition-allergy-page/nutrition-allergy-page.component';
import { ProfilePageComponent } from '../profile-page/profile-page.component';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { finalize } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { OrderListPageComponent } from '../order-list-page/order-list-page.component';
import { Router } from '@angular/router';
import { IStore, StoreService } from 'src/app/store/services/store.service';
import { MenuService } from 'src/app/store/services/menu.service';
import { AuthenticationPageComponent } from 'src/app/auth/pages/authentication-page/authentication-page.component';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AllInOneAuthPageComponent } from 'src/app/auth/pages/all-in-one-auth-page/all-in-one-auth-page.component';
import { PayRewardPageComponent } from '../pay-reward-page/pay-reward-page.component';

@Component({
  selector: 'app-plus-page',
  templateUrl: './plus-page.component.html',
  styleUrls: ['./plus-page.component.scss'],
  standalone: false
})
export class PlusPageComponent  implements OnInit {

  title: string = 'Nav.Profile';

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  get currentLanguages() {
    return this.translationService.getLanguage(); 
  }

  constructor(
    private injector: Injector,
    private modalCtrl: ModalController,
    public setting: SettingService,
    private navCtrl: NavController,
    public translationService: TranslationService,
    private loader: LoaderService,
    private router: Router,
    private storeService: StoreService,
    private menuService: MenuService,
    public auth: AuthService,
    private actionSheetController: ActionSheetController,
  ) { }

  ngOnInit() {

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
        
      }
    } catch (e) {

    }

    if (window.innerWidth <= 500) {
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }

  async changePage(page) {
    if(page == "FLAVOR") {
      console.log("flavor page");

      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }

      /*
      if(this.setting.configuration.uIoptions) {

      }
      */

      const modal = await this.modalCtrl.create({
        component: FlavorsPageComponent,
        cssClass: 'flavor-popup-model',
        componentProps: {
          disableHeader: true
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();

    } else if(page == "NUTRI-ALLERGY") {
      console.log("nutrition and allergy page");

      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }

      /*
      if(this.setting.configuration.uIoptions) {

      }
      */

      const modal = await this.modalCtrl.create({
        component: NutritionAllergyPageComponent,
        cssClass: 'nutrition-allergy-popup-model',
        componentProps: {
          disableHeader: true
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();

    } else if(page == "SETTINGS") {

      if(!this.auth.isAuthenticated) {
        return this.gotoLogin();
      }

      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }

      if(!this.auth.isAuthenticated) {
        if(this.setting.configuration.uIoptions?.loginToPopup) {
        
          // prevents crash if the undocked navbar is inside a popup
          const modal = await this.modalCtrl.create({
            component: AuthenticationPageComponent,
            cssClass: 'auth-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
          return;
        } else {
          this.router.navigate(['auth']);
          return;
        }
      }


      if(this.setting.configuration.uIoptions?.profileToPopup) {
        const modal = await this.modalCtrl.create({
          component: ProfilePageComponent,
          cssClass: 'profile-popup-model',
          componentProps: {
            disableHeader: true,
            profileView: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {

        console.log("navigating");

        this.navCtrl.navigateRoot('/account/profile', {
          state: { profileView: true }
        });

        
      }
      
    } else if(page == "CARD") {
      if(!this.auth.isAuthenticated) {
        return this.gotoLogin();
      }

      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }

      if(!this.auth.isAuthenticated) {
        if(this.setting.configuration.uIoptions?.loginToPopup) {
        
          // prevents crash if the undocked navbar is inside a popup
          const modal = await this.modalCtrl.create({
            component: AuthenticationPageComponent,
            cssClass: 'auth-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
          return;
        } else {
          this.router.navigate(['auth']);
          return;
        }
      }


      if(this.setting.configuration.uIoptions?.profileToPopup) {
        const modal = await this.modalCtrl.create({
          component: ProfilePageComponent,
          cssClass: 'profile-popup-model',
          componentProps: {
            disableHeader: true,
            profileView: false
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {


        this.navCtrl.navigateRoot('/account/profile', {
          state: { profileView: false }
        });

        
      }
    } else if(page == "TO-REWARDS-WALLET") {
      console.log("go to wallet");
      
      /*
      if(!this.auth.isAuthenticated) {
        return this.gotoLogin();
      }
      

      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }

      if(this.setting.configuration.uIoptions?.rewardsToPopup) {
        const modal = await this.modalCtrl.create({
          component: PayRewardPageComponent,
          cssClass: 'reward-popup-model',
          componentProps: {
            disableHeader: true,
            directWalletLink: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        this.navCtrl.navigateRoot('/account/pay-rewards', {
          state: { directWalletLink: true }
        });
      }
      */



      if(!this.auth.isAuthenticated) {
        return this.gotoLogin()
      }

      // doing a local import as i'm forced to prevent circular dependency
      const { PayPageComponent } = await import(
        '../pay-page/pay-page.component'
      );

      const modal = await this.modalCtrl.create({
        component: PayPageComponent,
        cssClass: 'pay-page-popup-model',
        componentProps: {
          //disableHeader: true,
          isPopup: true
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
      });

      if(this.isPopup) {
        await this.modalCtrl.dismiss();
      }
    
      await modal.present();
      
    } else if(page == "TO-ORDER") {
      console.log("go to default menu");


      //var order = this.menuService.order;

      
      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }
      
      //navigate to the first store this merchant has so it can lay a menu (only if it's not already on a menu)
      if (!this.router.url.includes('/stores/menu')) {

        this.storeService.getStores().subscribe((data: IStore[]) => {
          var stores = data;

          this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
        });
      }


      // in the storeService, there will be a value that will track whether the store was selected manually or not
      this.storeService.setSelectedStore = false;
      

    } else if(page == "ORDER-HISTORIC") {
      if(!this.auth.isAuthenticated) {
        return this.gotoLogin();
      }


      if(this.setting.configuration.uIoptions?.myOrdersToPopup) {
        // prevents crash if the undocked navbar is inside a popup
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }

        if(!this.auth.isAuthenticated) {
          if(this.setting.configuration.uIoptions?.loginToPopup) {
          
            // prevents crash if the undocked navbar is inside a popup
            const modal = await this.modalCtrl.create({
              component: AuthenticationPageComponent,
              cssClass: 'auth-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            await modal.present();
            return;
          } else {
            this.router.navigate(['auth']);
            return;
          }
        }
        

        const modal = await this.modalCtrl.create({
          component: OrderListPageComponent,
          cssClass: 'myorders-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        this.navCtrl.navigateRoot('/account/my-orders');
      }

    }
  }

  async showTerms(event) {
    event.preventDefault()
    //Fetch terms to SMA/Import them when importing the brand and query us
    const loader = await this.loader.create();
    await loader.present();
    this.setting.getSATerms(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: terms
          }
        });

        await requestModal.present();
      });
  }


  async showPolicies(event) {
    event.preventDefault();
    //Show SHOPACHAT policies
    const loader = await this.loader.create();
    await loader.present();
    this.setting.getSAPolicies(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Policies",
            content: terms
          }
        });

        await requestModal.present();
      });
  }

  getCurrentPath(): string {
    return this.router.url;
  }

  async OpenLoginModal() {
    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    var currentUrl = this.getCurrentPath();
    localStorage.setItem('Stateurl', currentUrl);

    if(this.setting.configuration.uIoptions?.loginToPopup) {
    
      // prevents crash if the undocked navbar is inside a popup
      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }


      const modal = await this.modalCtrl.create({
        component: AuthenticationPageComponent,
        cssClass: 'auth-popup-model',
        componentProps: {
          disableHeader: true
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    }
    
  }

  async logout() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translationService.translate('Auth.LogoutConfirmation'),
      buttons: [{
        text: this.translationService.translate('General.Yes'),
        handler: () => {
          // when the use logs out
          //this.analytics.conversionUpdate("logOut");

          this.auth.logout();
          this.router.navigateByUrl('');

          //gotta clear the linkCoupon in case another account log in and try to link some promotion.
          localStorage.removeItem('linkCoupon');
        }
      },
      {
        text: this.translationService.translate('General.No'),
        role: 'cancel'
      }]
    });

    actionSheet.present();
  }

  changeLang(lang: string) {

    localStorage['lang'] = lang;
    this.translationService.setLanguage(lang.toLowerCase());
  }

  useExternalLink(linkType: string){
    if(linkType == "facebook") {
      this.goToExternalSite(this.setting.configuration.link.facebook);
    } else if(linkType == "ticktock") {
      this.goToExternalSite(this.setting.configuration.link.tiktok);
    } else if(linkType == "instagram") {
      this.goToExternalSite(this.setting.configuration.link.instagram);
    } else if(linkType == "twitter") {
      this.goToExternalSite(this.setting.configuration.link.twitter);
    }
  }

  goToExternalSite(link) {
    const url = link.startsWith('http')
      ? link
      : `https://${link}`;

    window.open(url, '_blank');
  }

  async gotoLogin() {
    if(this.setting.configuration.uIoptions?.loginToPopup) {
      if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AllInOneAuthPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true,
            isPopup: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AuthenticationPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
      return;
    } else {
      if(this.setting.configuration.uIoptions?.allinOneAuthPage) { 
        this.router.navigate(['auth/fullauth']);
      } else {
        this.router.navigate(['auth']);
      }
      return;
    }

  }
}
